module.exports = __webpack_public_path__ + "img/e3894bf.png";